import { result } from "lodash";
import Vue from "vue";
import Vuex from "vuex";

const unitsDescription = require("@/units/units.json")

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    openUploadsData: null,
    dashboardDataMap: null,
    dashboardDataTools: null,
    groupSelected: "",
    groupServices: [],
    permissions: [],
    resultsData: null,
    apiEndpoints: {
      base: process.env.VUE_APP_API_SERVER,//"https://api.acquaint.cloud",
      pipescanner: {
        edit: "/pipescanner/inspections/v1/edit-inspection/",
        custom: "/pipescanner/inspections/v1/custom-query/",
        images: "/pipescanner/inspections/v1/images/",
        add_images: "/pipescanner/inspections/v1/add-images/"
      },
      clients: {
        groups: "/client/administration/v1/groups/",
        services: "/client/administration/v1/services/",
      },
      tools: {
        register: "/tools/v1/add-tool",
        query: "/tools/v1/get-tools",
        registerFirmware: "/tools/v1/register-firmware-datalogger/",
        editTool: "/tools/v1/edit-tool/",
        states: "/tools/v1/get-tools-states",
      },
    },
    details_page: {
      selected_inspections: null,
    },
    editPage: {
      selectedInspection: null,
    },
    editTool: null,
    language: "en",
    exportSettings: null,
    units: "metric",
    unitsDescription: unitsDescription,
  },
  mutations: {
    SET_UNITS(state, units) {
      state.units = units.toLowerCase();
    },
    SET_EXPORT_SETTINGS(state, settings) {
      state.exportSettings = settings;
    },
    SET_LANGUAGE(state, lang) {
      state.language = lang;
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
    SET_GROUP_SELECTED(state, group) {
      state.groupSelected = group;
    },
    SET_GROUP_SERVICES(state, services) {
      state.groupServices = services;
    },
    SET_SELECTED_INSPECTIONS(state, inspections) {
      state.details_page.selected_inspections = inspections;
    },
    SET_SELECTED_EDIT(state, inspectionId) {
      state.editPage.selectedInspection = inspectionId;
    },
    SET_SELECTED_EDIT_TOOL(state, toolObject) {
      state.editTool = toolObject;
    },
    SET_RESULTS_DATA(state, resultsData) {
      state.resultsData = resultsData;
    },
    SET_DATA_DASHBOARD_MAP(state, data) {
      state.dashboardDataMap = data;
    },
    SET_DATA_DASHBOARD_TOOLS(state, data) {
      state.dashboardDataTools = data;
    },
    SET_DATA_OPEN_UPLOADS(state, data){
      state.openUploadsData = data;
    }

  },
});
